const PARTNER_MANAGEMENT_PHONE = '+41 43 833 00 21';

const telHref = (phone: string): string => `tel:${phone.replace(/[^+\d]/g, '')}`;

export const houzyContact = {
    infoEmail: 'info@houzy.ch',
    supportEmail: 'support@houzy.ch',
    partnerManagementPhoneNumber: PARTNER_MANAGEMENT_PHONE,
    partnerManagementPhoneHref: telHref(PARTNER_MANAGEMENT_PHONE),
} as const;
